import React from 'react';
import { Reveal } from '../Reveal';
import { coach } from '../../config/coach';

const AboutSection = () => {
  return (
    <section id="about" className="relative bg-black py-24 sm:py-32" data-testid="about-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {/* Story */}
          <div className="lg:col-span-7 order-2 lg:order-1">
            <Reveal>
              <span className="kicker">{coach.about.kicker}</span>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-display font-bold uppercase text-ivory tracking-tight leading-[0.9] text-5xl sm:text-6xl lg:text-7xl mt-5">
                {coach.about.heading}
              </h2>
            </Reveal>
            <div className="mt-8 space-y-5 max-w-xl">
              {coach.about.paragraphs.map((p, i) => (
                <Reveal key={i} delay={0.08 + i * 0.04}>
                  <p className="text-white/65 text-base sm:text-lg leading-relaxed">{p}</p>
                </Reveal>
              ))}
              <Reveal delay={0.3}>
                <p className="font-display uppercase tracking-[0.2em] text-gold-soft text-lg pt-2">{coach.about.signature}</p>
              </Reveal>
            </div>
          </div>

          {/* Editorial image pair — gym (primary) + athlete (secondary) */}
          <div className="lg:col-span-5 order-1 lg:order-2">
            <Reveal delay={0.1}>
              <div className="relative w-full aspect-[4/5] overflow-hidden rounded-2xl border border-white/10">
                <img
                  src={coach.images.about}
                  alt={`${coach.fullName} training`}
                  className="w-full h-full object-cover object-[50%_18%] img-grade"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-transparent to-transparent" />
                <div className="absolute bottom-4 left-4 right-4 flex items-end justify-between">
                  <span className="font-display uppercase tracking-[0.2em] text-white/90 text-sm">{coach.about.imageLabel}</span>
                  <span className="text-gold-soft/80 text-[10px] uppercase tracking-[0.25em]">{coach.about.imageTag}</span>
                </div>
              </div>
            </Reveal>

            <Reveal delay={0.16}>
              <div className="relative mt-4 w-full aspect-[16/11] overflow-hidden rounded-2xl border border-white/10">
                <img
                  src={coach.images.aboutSecondary}
                  alt={`${coach.fullName} — competitive athlete`}
                  className="w-full h-full object-cover object-[50%_28%] img-grade"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-transparent" />
                <span className="absolute bottom-3 left-4 text-white/60 text-[10px] uppercase tracking-[0.28em]">
                  {coach.about.secondaryCaption}
                </span>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
